export default __webpack_public_path__ + "ac12488c77ecad2e383b74312dbde054.png";